<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form ref="infoForm" label-width="70px" class="info-form">
        <el-form-item label="模板名称">
          <el-input
            placeholder="请输入模板名称"
            v-model="detail.name"
            disabled
            style="width: 30%"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否包邮">
          <el-checkbox-group v-model="arr" @change="select" disabled>
            <el-checkbox
              v-for="item in types"
              :label="item.value"
              :key="item.value"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- <el-checkbox v-model="checked1">自定义邮费</el-checkbox>
          <el-checkbox v-model="checked2">包邮</el-checkbox> -->
        </el-form-item>
        <el-form-item label="运送方式">
          <el-checkbox v-model="checked1" disabled>
            快递（除指定地区外，其余地区的运费采用“默认运费”）</el-checkbox
          >
        </el-form-item>
        <el-form-item label="邮费设置">
          <div style="margin-top: 14px"></div>
          <number
            :style="{ marginBottom: tableDataF.length == 0 ? '20px' : '' }"
            v-if="detail.calculType == 1"
            :isEdit="false"
            :tableData="tableData"
            :freight="detail.freight"
            :baseNumber="detail.baseNumber"
            :addNum="detail.addNum"
            :addPrice="detail.addPrice"
          ></number>
          <weight
            v-if="detail.calculType == 2"
            :isEdit="false"
            :tableData="tableData"
            :freight="detail.freight"
            :baseNumber="detail.baseNumber"
            :addNum="detail.addNum"
            :addPrice="detail.addPrice"
          ></weight>
        </el-form-item>

        <el-form-item label="" v-if="tableDataF.length != 0">
          <!-- <el-radio :label="3">指定条件包邮（可选）</el-radio> -->
          <free-delivery
            :tableData="tableDataF"
            style="margin-top: 10px"
            :isEdit="false"
          ></free-delivery>
        </el-form-item>
      </el-form>
    </div>
    <div class="back-btn">
      <el-button type="info" @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import FreeDelivery from '../components/freeDelivery.vue'
import number from '../components/number.vue'
import weight from '../components/weight.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    number,
    weight,
    FreeDelivery
  },
  data () {
    return {
      types: [
        {
          name: '自定义邮费',
          value: '1'
        },
        {
          name: '包邮',
          value: '0'
        },
      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '运费模板', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '查看运费模板', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      arr: []
    }
  },
  created () {
    this.getDetail()
  },

  methods: {
    back () {
      this.$router.go(-1)
    },
    select () {
      console.log(this.arr)
    },
    getDetail () {
      let data = {
        id: this.$route.query.id
      }
      this.axios.post('/goods/shippingDetail', data)
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data
            this.tableData = this.detail.regions || []
            this.tableData.forEach(item => {
              Object.assign(item, { address: item.betterAddress })
              Object.assign(item, { addressData: JSON.parse(item.regionJson) })
            })
            this.tableDataF = this.detail.freeList || []
            if (this.tableDataF) {
              this.tableDataF.forEach(item => {
                Object.assign(item, { address: item.betterAddress })
                Object.assign(item, { addressData: JSON.parse(item.regionJson) })
              })
            }

            this.arr = []
            let a = this.detail.isFree ? '0' : '1'
            this.arr.push(a)
            this.$forceUpdate()
          }
        })
    },
    handleCurrentChange () {

    },
    handleSizeChange () {

    },
    handleSelectionChange () {

    }
  }
}
</script>
<style scoped lang="scss">
.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;
  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

